import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import TableBase from "./Base";
import { convertMinutesToTime, getTranslation } from "../../utils/helper";

import { DATETIME_FORMAT_FRONTEND, DATE_FORMAT_FRONTEND } from "../../constants";

const RoutePlansTable = ({ scrollHeight, actionWidth, withAction, setting, ...props }) => {
  const COLUMNS = [
    {
      title: getTranslation(setting, "Route Plans", "Route Plan Name"),
      dataIndex: "name",
      fixed: true,
      width: 200,
      render(value, record) {
        return (
          <Link to={"/route-plans/" + record._id} className="RoutePlanName">
            {value}
          </Link>
        );
      },
    },
    {
      title: "Company",
      dataIndex: "Company",
      fixed: true,
      width: 200,
      render(value, record) {
        return record?.company?.name || "";
      },
    },
    {
      title: getTranslation(setting, "Route Plans", "Type"),
      dataIndex: "type",
      width: 100,
    },
    {
      title: getTranslation(setting, "Route Plans", "Date"),
      dataIndex: "deliveryDate",
      width: 200,
      render(value) {
        return value ? moment(value).utc().locale(setting.systemLanguage).format(DATE_FORMAT_FRONTEND) : "";
      },
    },
    {
      title: getTranslation(setting, "Route Plans", "# of Orders"),
      dataIndex: "orders",
      width: 110,
      render(value) {
        return value.length;
      },
    },
    {
      title: getTranslation(setting, "Route Plans", "# of Drivers"),
      dataIndex: "drivers",
      width: 110,
      render(value) {
        return value.length;
      },
    },
    {
      title: getTranslation(setting, "Route Plans", "Updated At"),
      dataIndex: "updatedAt",
      width: 250,
      render(value) {
        return value ? moment(value).locale(setting.systemLanguage).format(DATETIME_FORMAT_FRONTEND) : "-";
      },
    },
    {
      title: getTranslation(setting, "Route Plans", "Distance"),
      dataIndex: ["report", "distance"],
      width: 150,
      render(value) {
        return value ? `${value / 1000} km` : "-";
      },
    },
    {
      title: getTranslation(setting, "Route Plans", "Travel Time"),
      dataIndex: ["report", "travelMins"],
      width: 150,
      render(value) {
        return convertMinutesToTime(value);
      },
    },
    {
      title: getTranslation(setting, "Route Plans", "Service Time"),
      dataIndex: ["report", "serviceMins"],
      width: 150,
      render(value) {
        return convertMinutesToTime(value);
      },
    },
    {
      title: getTranslation(setting, "Route Plans", "Working Time"),
      dataIndex: ["report", "workingMins"],
      width: 150,
      render(value) {
        return convertMinutesToTime(value);
      },
    },
    {
      title: getTranslation(setting, "Route Plans", "Waiting Time"),
      dataIndex: ["report", "waitingMins"],
      width: 150,
      render(value) {
        return convertMinutesToTime(value);
      },
    },
    {
      title: getTranslation(setting, "Route Plans", "Working %"),
      dataIndex: ["report", "workingPercentage"],
      width: 150,
      render(value) {
        return value ? `${value} %` : "-";
      },
    },
    {
      title: getTranslation(setting, "Route Plans", "Status"),
      dataIndex: "status",
      width: 130,
      fixed: "right",
      render(status) {
        return (
          <span className={"status routePlanStatus " + status.toLowerCase()}>
            {getTranslation(setting, "Route Plans", status)}
          </span>
        );
      },
    },
  ];

  if (withAction) {
    COLUMNS.push({
      key: "action",
      width: actionWidth || 100,
      fixed: "right",
      render(record) {
        return withAction(record);
      },
    });
  }

  if (scrollHeight) {
    return <TableBase columns={COLUMNS} scroll={{ x: 991, y: scrollHeight }} {...props} />;
  } else {
    return <TableBase columns={COLUMNS} scroll={{ x: 991 }} {...props} />;
  }
};

export default RoutePlansTable;
